import { Rating } from "components";
import React, { FC } from "react";

type Props = {
  type: "DESKTOP" | "TABLET";
  data?: { name: string; description: string };
};

const Title: FC<Props> = ({ type = "DESKTOP", data }) => {
  return (
    <div
      className={`${
        type == "DESKTOP"
          ? "absolute right-[45%] top-0 hidden text-white lg:block"
          : "block text-black-450 lg:hidden"
      }  h-full px-5  lg:px-0`}
    >
      <div className="mb-7 flex h-full flex-col justify-center pt-5 ">
        <h1 className="mb-7 text-sm font-bold md:text-3xl lg:pl-10">
          {data?.name}
        </h1>
        <p
          className={`${type == "DESKTOP" && "pl-36"} mb-8 text-xs md:text-lg`}
        >
          {data?.description}
        </p>
        {/* <div className="flex">
                    <span className="text-xs md:text-base">امتیاز دوره از نظر کاربران</span>
                    <Rating value={4} readOnly />
                </div> */}
      </div>
      {/* <div
                className="my-7 flex h-px w-full md:hidden"
                style={{
                    background:
                        'linear-gradient(270deg, rgba(54, 100, 148, 0.8) 0%, rgba(4, 128, 212, 0.8) 50%, rgba(39, 178, 188, 0.8) 100%)',
                }}
            /> */}
    </div>
  );
};

export default Title;
